import React from 'react';
import { BiBookOpen } from 'react-icons/bi';
import './DocsShell.css';

/**
 * Help hub chrome — sections are internal (no second sidebar item).
 */
export default function DocsShell({
  title,
  subtitle,
  sections,
  activeSection,
  onSection,
  toc,
  children
}) {
  return (
    <div className='docsShell'>
      <header className='docsShell-header'>
        <div className='docsShell-brandRow'>
          <div className='docsShell-brand'>
            <span className='docsShell-brandMark' aria-hidden>
              <BiBookOpen />
            </span>
            Help
          </div>
          {sections?.length ? (
            <div className='docsShell-sections' role='tablist' aria-label='Help sections'>
              {sections.map((s) => (
                <button
                  key={s.id}
                  type='button'
                  role='tab'
                  aria-selected={activeSection === s.id}
                  className={`docsShell-secBtn${activeSection === s.id ? ' isActive' : ''}`}
                  onClick={() => onSection(s.id)}
                >
                  {s.label}
                </button>
              ))}
            </div>
          ) : null}
        </div>
        <h1 className='docsShell-title'>{title}</h1>
        {subtitle ? <p className='docsShell-subtitle'>{subtitle}</p> : null}
      </header>

      <div className='docsShell-scroll'>
        <div className={`docsShell-body${toc?.length ? ' hasToc' : ''}`}>
          {toc?.length ? (
            <nav className='docsShell-toc' aria-label='On this page'>
              <p className='docsShell-tocTitle'>On this page</p>
              {toc.map((item) => (
                <a key={item.id} href={`#${item.id}`}>
                  {item.label}
                </a>
              ))}
            </nav>
          ) : null}
          <div className='docsShell-main'>{children}</div>
        </div>
      </div>
    </div>
  );
}

export function DocsCard({ id, title, children }) {
  return (
    <section className='docsShell-card' id={id}>
      {title ? <h2>{title}</h2> : null}
      {children}
    </section>
  );
}

export function DocsNote({ children, danger = false }) {
  return <div className={`docsShell-note${danger ? ' danger' : ''}`}>{children}</div>;
}

export function DocsCode({ label, text, copySlot }) {
  return (
    <div className='docsShell-preWrap'>
      {(label || copySlot) && (
        <div className='docsShell-preHead'>
          <span>{label || 'Code'}</span>
          {copySlot || null}
        </div>
      )}
      <pre>
        <code>{text}</code>
      </pre>
    </div>
  );
}

export function DocsFeature({ title, children }) {
  return (
    <div className='docsShell-feature'>
      <div className='docsShell-featureTitle'>{title}</div>
      <div className='docsShell-featureBody'>{children}</div>
    </div>
  );
}
